module.exports = __webpack_public_path__ + "img/pioneer-mockup.6eb37d42.jpg";